import { render, staticRenderFns } from "./ThreePointIntro.vue?vue&type=template&id=575be33a&scoped=true&"
import script from "./ThreePointIntro.vue?vue&type=script&lang=js&"
export * from "./ThreePointIntro.vue?vue&type=script&lang=js&"
import style0 from "./ThreePointIntro.vue?vue&type=style&index=0&id=575be33a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575be33a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
